import { useMutation } from 'react-query';
import { Http } from '../../services/Http';
import { MUTATION_KEYS } from '../constants';
import { useInvalidateHolidays } from './useHolidays';
import { Holiday } from '../../types';

type AddHolidayPayload = {
  data: AddHoliday[];
}

type AddHoliday = {
  type: string;
  name: string;
  country: string;
  startDate: string;
  endDate: string;
};

async function bulkAddHoliday(payload: AddHoliday[]): Promise<Holiday[]> {
  const { data } = await Http.axios.post<AddHolidayPayload, Holiday[]>(`/holiday/bulk`, {
    data: payload
  });
  return data;
}

export const useBulkAddHolidays = () => {
  const invalidateHolidays = useInvalidateHolidays();
  return useMutation(bulkAddHoliday, {
    mutationKey: MUTATION_KEYS.ADD_BULK_HOLIDAY_KEY,
    onSuccess: () => {
      invalidateHolidays();
    },
  });
};
